import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AdminServices from "../../services/AdminServices";
import BusinessServices from "../../services/BusinessServices";
import { notifyError, notifySuccess } from "../../utils/toast";
import useSelectStore from "../useSelectStore";

const useBusinessSubmit = ({ handleClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { handleStoreSelect } = useSelectStore();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    control,
  } = useForm({

  });

  const storeName = watch("name", "");

  const onSubmit = async (data) => {
    //
    if (!data.name) {
      notifyError("Business Name is required");
      return;
    }
    setIsLoading(true);
    try {
      const combinedData = {
        ...data,
        attributes: {
          staff_strength: data.staff_strength,
          industry: data.industry,
          sub_industry: data.sub_industry,
          departments: data.departments,
        }
      };

      const res = await BusinessServices.createBusiness(combinedData);
      const refreshToken = await AdminServices.refreshToken();
      // console.log("------- Create Team Response Payload:    ", res);
      notifySuccess("Welcome to your brand new workspace!");
      await handleStoreSelect(res?.data?.business?.business_code, refreshToken?.data);
      if (handleClose && typeof handleClose === "function") {
        handleClose();
      }
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      notifyError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isLoading,
    storeName,
    Controller,
    control,
    watch,
    setValue,
  };
};

export default useBusinessSubmit;
